import React, { useState, useEffect } from "react";
import { Button, Stack, Grid } from "@mui/material";
import WebRTCCustomer from "./WebRTCCustomer";
import { useParams } from "react-router-dom";
import Background from "../CustomerBG.png";
import Logo from "../Logo.svg";
import { useLocation } from "react-router-dom";


const CustomerScreen = () => {
  const [isexpired, setIsExpired] = useState(false);
  const [rendercontent, setRendercontent] = useState(false);
  const [conf, setConf] = useState({
    connection: false,
    roomId: "",
    isEngineer: false,
    audio: true,
    video: true,
  //   iceServers: [
  //     {
  //       urls: "stun:stun.relay.metered.ca:80",
  //     },
  //     {
  //       urls: "turn:standard.relay.metered.ca:80",
  //       username: "70ff889cb444e997cce1cb9a",
  //       credential: "rOnE8d8I9x7oau6N",
  //     },
  //     {
  //       urls: "turn:standard.relay.metered.ca:80?transport=tcp",
  //       username: "70ff889cb444e997cce1cb9a",
  //       credential: "rOnE8d8I9x7oau6N",
  //     },
  //     {
  //       urls: "turn:standard.relay.metered.ca:443",
  //       username: "70ff889cb444e997cce1cb9a",
  //       credential: "rOnE8d8I9x7oau6N",
  //     },
  //     {
  //       urls: "turns:standard.relay.metered.ca:443?transport=tcp",
  //       username: "70ff889cb444e997cce1cb9a",
  //       credential: "rOnE8d8I9x7oau6N",
  //     },
  // ],

  iceServers: [
    {
      urls: "stun:4.186.152.93:3478",
    },
    {
      urls: "turn:4.186.152.93:3478",
      username: "TURNu",
      credential: "TURNp",
    }
   
],
    socketIoPath: process.env.REACT_APP_API_URL,
  });
  const { id } = useParams();

  const urlparams = new URLSearchParams(window.location.search);
  const expirationtime = parseInt(urlparams.get("tf"));
  const currenttime = Date.now();
  const storedLink_customer = localStorage.getItem("customlink_customer");
  const useQuery = () => new URLSearchParams(useLocation().search);
  const query = useQuery();
  const uuid = query.get('uu');
    const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
      const uu = uuidRegex.test(uuid)
      console.log("the regex test is", uu)

      console.log("the expiration time in customer is", expirationtime);


  console.log("the uuid is ", uuid);
  useEffect(() => {
    const checkexpiry = () => {
      if (currenttime >= expirationtime) {
        setIsExpired(true);
      } else {
        setIsExpired(false);
      }
      console.log("the url params", urlparams);
      console.log("the currenttime", expirationtime);
      console.log("the link is", window.location.href);
      console.log("the stored  is", storedLink_customer);
    };

    checkexpiry();

    const interval = setTimeout(() => {
      console.log("checking expiration");
      checkexpiry();
      setRendercontent(true);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [expirationtime, currenttime]);

  const setConfigurattion = (args) => {
    let tempConf = { ...conf };
    args.forEach((element) => {
      tempConf[element.type] = element.value;
    });
    setConf(tempConf);
  };

  const joinAvailableRoom = (type) => {
    setConfigurattion([
      { type: "roomId", value: id },
      { type: "video", value: type.video },
      { type: "connection", value: true },
    ]);
  };
  const OnError = (msg) => {
    setConfigurattion([{ type: "connection", value: false }]);
    if (msg === "Permission denied") {
      alert("Please allow all permissions to proceed");
      alert(
        "Please click on secure icon before https://... and select site settings then camera permission"
      );
      alert(
        "Please click on secure icon before https://... and select site settings then microphone permission"
      );
    } else {
      alert("Your system is not capable to have video call", msg);
    }
  };

  const onClose = () => {
    setConfigurattion([{ type: "connection", value: false }]);
  };

  return (
    <>
    { isexpired || !expirationtime ?
      (<h1>The link is not valid</h1>):(
        <div
        // className='portrait-lock'
        style={{
          height: "100svh",
          // margin: "0px",
          background: "rgb(34,193,195)",
          // background:
          //   "linear-gradient(0deg, rgba(34,193,195,1) 0%, rgba(255,207,103,1) 100%)",
          // backgroundImage: "url('/home/clouduser/Remote_Assistance/Client/public/Support.jpg')",
          // backgroundSize: "cover",
          // backgroundRepeat: "no-repeat",
          backgroundImage: `url(${Background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* {showalert && (
              <div>
                  <h1>keep the phone in potrait mode</h1>
                  </div>
            )} */}
  
        {conf.connection ? (
          <WebRTCCustomer conf={conf} onClose={onClose} OnError={OnError} />
        ) : (
          <Grid
            container
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Stack direction="column" spacing={1} p={1}>
              {/* <OutlinedInput size='small' onChange={handelSendData} />
                  <Button variant='contained' color='error' onClick={disconnect} >disconnect</Button> */}
  
              {/* <TextField label="Room ID" value={ conf.roomId } onChange={ ( e ) => { setConfigurattion( [ { type: 'roomId', value: e.target.value } ] ); } } /> */}
  
              {/* <Button variant='contained' onClick={() => joinAvailableRoom({ video: false })} >Audio</Button> */}
              <img src={Logo} alt="client logo" style={{ margin: "10px auto" }} />
  
              <h1
                style={{ color: "white", textAlign: "center", marginTop: "28vh" }}
              >
                Welcome to <br />
                AR Remote Assistance
              </h1>
              <br />
  
              <Button
                variant="contained"
                onClick={() => joinAvailableRoom({ video: true })}
                style={{ marginTop: "30vh" }}
              >
                Join the Video Call
              </Button>
            </Stack>
          </Grid>
        )}
      </div>
      )
    }
</>
  );
};

const Customer = () => {
  return <CustomerScreen />;
};

export default Customer;
